/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 03.08.17.
 */

import React from "react";
import PropTypes from "prop-types";
import {Modal} from "./Bootstrap"
import t from "../trans";

class Confirmation extends React.Component {
    static propTypes = {
        /**
         * Confirmation dialog title. If not specified then "Confirmation"
         */
        title: PropTypes.string,
        /**
         * Confirmation message.
         */
        message: PropTypes.string.isRequired,
        /**
         * "Yes" button text. Set undef if button should be not present.
         */
        yesButton: PropTypes.string,
        /**
         * "No" button text. Set undef if button should be not present.
         */
        noButton: PropTypes.string,
        /**
         * Set false if there is not allowed to close dialog by clicking outside of the window.
         */
        allowClose: PropTypes.bool,
        /**
         * Show the confirmation dialog. Default is true.
         */
        show: PropTypes.bool,
        /**
         * Callback called when user clicks to "Yes" or "No" button or when user closes the dialog window.
         * Signature:
         *  onClick(isYesClicked)
         */
        onClick: PropTypes.func
    };

    static defaultProps = {
        title: t("Confirmation"),
        yesButton: t("YES"),
        noButton: t("NO"),
        allowClose: true,
        show: true
    };

    constructor(props) {
        super(props);
        this.state = {
            show: props.show
        };
        this.onClickNo = this.onClickNo.bind(this);
        this.onClickYes = this.onClickYes.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.show !== nextProps.show) this.setState({show: nextProps.show});
    }

    onClickNo() {
        this.setState({show: false});
        if (this.props.onClick) this.props.onClick(false);
    }

    onClickYes(e) {
        e.preventDefault();
        this.setState({show: false});
        if (this.props.onClick) this.props.onClick(true);
    }

    render() {
        return (
            <Modal onClose={this.onClickNo} show={this.state.show} modalAttrib={this.props.allowClose ? {} : {"data-backdrop": "static", "data-keyboard": "false"}}>
                <Modal.Content>
                    <Modal.Header>
                        {
                            this.props.allowClose ?
                                (<button type="button" className="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span className="sr-only">{t("Close")}</span></button>) :
                                ""
                        }
                        <h4 className="modal-title">{this.props.title}</h4>
                    </Modal.Header>
                    <Modal.Body>
                        {this.props.message}
                    </Modal.Body>
                    <Modal.Footer>
                        {
                            this.props.noButton ?
                                (<button type="button" className="btn btn-white" data-dismiss="modal">{this.props.noButton}</button>) :
                                ""
                        }
                        {
                            this.props.yesButton ?
                                (<button type="button" className="btn btn-primary" onClick={this.onClickYes}>{this.props.yesButton}</button>) :
                                ""
                        }
                    </Modal.Footer>
                </Modal.Content>
            </Modal>
        );
    }
}

export default Confirmation;
